export default {
  intl: 'https://www.facebook.com/nuinalp',
  'pt-br': 'https://www.facebook.com/nuinalpbr',
} as const;
